import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {PageHeader} from 'antd';
import Line from '@ant-design/charts/es/line';

import DateRange from '../component/DateRange';
import {getRangeReports} from '@/api/report';
import ChartDownloader from '../component/ChartDownloader';

NewsChart.propTypes = {
    appId: PropTypes.string.isRequired,
    alias: PropTypes.string.isRequired,
};

function NewsChart({appId, alias}) {
    const chartRef = useRef();
    const [lineData, setLineData] = useState([]);

    async function onChange(dates, dateStrings) {
        // console.log(dates, dateStrings);
        const {data = []} = await getRangeReports(alias, appId, dateStrings[0], dateStrings[1]);
        // console.log(data);

        const newData = data.reduce((accumulator, currentValue) => {
            const {reportDate, sendCount, newsCount, toUserCount} = currentValue;

            accumulator.push({
                category: '群发图文（次）',
                date: reportDate,
                value: sendCount,
            });
            accumulator.push({
                category: '文章（篇）',
                date: reportDate,
                value: newsCount,
            });
            accumulator.push({
                category: '群发人数',
                date: reportDate,
                value: toUserCount,
            });

            return accumulator;
        }, []);
        setLineData(newData);
    }

    return (
        <>
            <PageHeader
                title="趋势图"
                style={{padding: '16px 0'}}
                extra={
                    <DateRange onChange={onChange}>
                        <ChartDownloader chartRef={chartRef} name="图文趋势图.png" />
                    </DateRange>
                }
            />
            <Line
                data={lineData}
                chartRef={chartRef}
                padding="auto"
                xField="date"
                yField="value"
                seriesField="category"
                smooth
                color={['#29cc97', '#1890ff', '#722ed1']}
                point={{shape: 'circle'}}
            />
        </>
    );
}

export default NewsChart;
